import { defineStore } from "pinia";

export const useUserinfoStore = defineStore('userinfo',{
    state(){
        return {
            username: localStorage.getItem('username') || '',
            nickName: localStorage.getItem('nickName') || '',
            password:'',
            clientId:'',
            isLang:false,
            kind:'',
            token: localStorage.getItem('token') || ''
        }
    },
    getters:{
        getUsername(state){
            return state.username
        },
        getNickName(state){
            return state.nickName
        },
        getPassword(state){
            return state.password
        },
        getClientId(state){
            return state.clientId
        },
        getisLang(state){
            return state.isLang
        },
        getkind(state){
            return state.kind
        },
        getToken(state){
            return state.token
        }
    },
    actions:{
        setUsername(username:string){
            this.username = username
            localStorage.setItem('username', username)
        },
        setNickName(nickName:string){
            this.nickName = nickName
            localStorage.setItem('nickName', nickName)
        },
        setPassword(password:string){
            this.password = password
        },
        setClientId(clientId:string){
            this.clientId = clientId
        },
        setisLang(isLang:boolean){
            this.isLang = isLang
        },
        setkind(kind:string){
            this.kind = kind
        },
        setToken(token:string){
            this.token = token
            localStorage.setItem('token', token)
        },
        clearUserInfo(){
            this.username = ''
            this.nickName = ''
            this.password = ''
            this.token = ''
            localStorage.removeItem('username')
            localStorage.removeItem('nickName')
            localStorage.removeItem('token')
        }
    }
})